export default __webpack_public_path__ + "static/media/GoogleFit_Logo_Vertical.0368927f.png";